import { Suspense, useMemo } from "react";

import { useDataFetch } from "../../../../hooks/useDataFetch2";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion"
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { useValidadorAsientosContablesContext } from "../../../../context/validadorAsientosContablesContext";
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { useColumnsAsientosDescuadrados } from "../utils/columnsAsientosDescuadrados";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";

const urlTabla = `siscred-api-contabilizacion/v1/peoplesoft/obtenerasientosdescuadrado`;

function ResumenDescuadradosComponent(){

    const { formFilters } = useValidadorAsientosContablesContext();

    const params = useMemo(() => {
        const p = new URLSearchParams();
        p.set("fechaDesde", formFilters!.fechaInicio!.toISOString().split("T")[0]);
        p.set("fechaHasta", formFilters!.fechaFin!.toISOString().split("T")[0]);
        p.set("codigoAccion", formFilters!.codigoAccion == 'Todas' ? '' : formFilters!.codigoAccion);
        p.set("numeroOperacion", formFilters!.numeroOperacion ? formFilters!.numeroOperacion : '');
        return p;
    }, [formFilters]);

    const dataTable = useDataFetch(
        urlTabla,
        params,
        true,
    );
    
    const { COLUMNS } = useColumnsAsientosDescuadrados();
    const columns = useMemo(() => COLUMNS, [dataTable]);

    return (
        <CustomAccordion title={'Asientos descuadrados'} expandedDefault>
            <Suspense>
                <Tabla
                    columns={columns}
                    control={dataTable}
                    url={urlTabla}
                    titulo={
                        <TableHeader
                            title=""
                            control={dataTable}
                            buttonExport={
                                <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                <MButton
                                    type="button"
                                    variant="outlined"
                                    onClick={() => exportExcel(dataTable.data, columns, "resumenAsientosDescuadrados")}
                                    startIcon={<SummarizeTwoToneIcon />}
                                >
                                    Exportar
                                </MButton>
                                </PermissionGuard>
                            }
                        />
                    }
                />
            </Suspense>
        </CustomAccordion>
    )
}

export default ResumenDescuadradosComponent;
